var utils = require('./sv-jedesheim.utils.js');

function ajaxCall(url, type, data, done) {
	ajaxCallExtended(url, type, data, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, null, done);
}

function ajaxCallExtended(url, type, data, processData, contentType, headerKeys, fail, done) {

	container = $('#content');

	var promise = $.ajax({
		url: url,
		type: type,
		data: data,
		async: true,
		processData: processData,
		contentType: contentType,
		beforeSend: function (xhr) {
			if (headerKeys !== null) {
				xhr.setRequestHeader(headerKeys[0], headerKeys[1]);
			}
			xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
		}
	}).done(function (data) {
		if (/^FAILS/.test(data) || /^Error/.test(data)) {
			// TODO
			// $.bigBox({
			// 	title : trans('extrax2-webadmin.error'),
			// 	content: trans('extrax2-webadmin.error_message'),
			// 	color: "#CA4862",
			// 	sound: $.sound_off,
			// 	icon: "fa fa-warning shake animated"
			// });

			return;
		}
		
		done(data);
	}).fail(function (error) {
		if (fail === null) {
			if (error.status == "401") {
				location.reload();
			} else {
				// utils.setHtmlData($("#content"), error.responseText);
			}
		} else {
			fail(error);
		}
	});

	return promise;
}

function ajaxSucceeded(data) {

	if (/^FAILS/.test(data)) {
		// TODO
		// $.bigBox({
		// 	title : trans('extrax2-webadmin.error'),
		// 	content: trans('extrax2-webadmin.error_message'),
		// 	color: "#CA4862",
		// 	sound: $.sound_off,
		// 	icon: "fa fa-warning shake animated"
		// });

		return false;
	}

	return true;
}

module.exports.ajaxCall = ajaxCall;
module.exports.ajaxCallExtended = ajaxCallExtended;
module.exports.ajaxSucceeded = ajaxSucceeded;
